<template>
  <div>

    <FrameHeader/>

    <!-- 旧的顶部筛选条 -->
    <div v-if="0" class="bg-white pt-4 pb-3">
      <div class="boxed d-flex align-items-center flex-wrap">

        <div class="ui-tabset">
          <span 
            v-for="item of home_tabs"
            :key="item.id"
            @click="on_tab = item.id"
            :class="['tab size-big',{'on': on_tab == item.id}]"
          >
            {{lg('',item.name)}}
          </span>
        </div>

        <CpBtnSortList
          class="pc-ml-auto mb-2"
          v-model="on_filter"
        />
      </div>
    </div>

    <div class="boxed py-5" style="max-width: 1000px;">

      <div v-for="(item,index) of store_list" 
        :key="index"
        class="mb-5 sp-banner-btn"
        >
        <router-link :to="{
          name: 'store_list',
          query: {
            store: item.id,
          },
        }">
          <img :src="'/static/pic/store_post/'+item.img" style="max-width: 100%;">
        </router-link>
      </div>
    </div>

    <FrameFooter/>

  </div>
</template>

<script>
import home_tabs from '../home/home_tabs.js'

export default {
  name: 'store',
  components: {},
  props: [],
  data() {
    return {
      on_tab: 'all',
      on_filter: '',
      home_tabs: home_tabs,

      store_list: [
        {
          id: 'DEGO',
          img: '1DEGOstore.png',
        },
        // {
        //   id: 'ALPACA',
        //   img: '2ALPACAstore.png',
        // },
        {
          id: 'ALICE',
          img: '3ALICEstore.png',
        },
        {
          id: 'BONDLY',
          img: '4BONDLYstore.png',
        },
        {
          id: 'JGN',
          img: '5JGNstore.png',
        },
        {
          id: 'CAKE',
          img: '6CAKEstore.png',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .sp-banner-btn{
    img{
      display: block;
      border: 1px solid #ddd;
      border-radius: 5px;
      margin: 0 auto;
      cursor: pointer;
    }
  }

  .sp-commingsoon{
    border-radius: 15px;
    // background: url('/static/pic/page_store/bg_comingsoon.jpg') center center;
    background-size: cover;
    border: 1px solid mix(#fff,$c,70);

    height: 250px;

    @media(max-width: 788px){
      height: 100px;
    }
  }
</style>